import { authHeader, BASE_URL, handleResponse, handleResponseBlob } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

function get(query, page, pageSize) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };
    return fetch(`${BASE_URL}api/profiles/syncable?page=${page}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function exportCSV(query) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };
    return fetch(`${BASE_URL}api/profiles/syncable/export`, requestOptions)
        .then(handleResponseBlob)
        .then(captureOnSuccess(ProductEvent.DataExported, { resource: 'listings' }));
}

function getFilterData() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/profiles/syncable/filter-options`, requestOptions).then(handleResponse);
}

function startSync() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/profiles/syncable/start-sync`, requestOptions).then(handleResponse);
}

function resolveConflictsGoogle(profileId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/profiles/google/${profileId}/resolve-conflicts`, requestOptions).then(handleResponse);
}

function resolveConflictsFacebook(profileId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/profiles/facebook/${profileId}/resolve-conflicts`, requestOptions).then(
        handleResponse,
    );
}

function enableProfileSync(profileId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/profiles/syncable/${profileId}:enableSync`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.ListingSyncEnabled));
}

function disableProfileSync(profileId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/profiles/syncable/${profileId}:disableSync`, requestOptions).then(handleResponse);
}

function getVerificationOptions(profileId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/profiles/google/${profileId}/verification-options`, requestOptions).then(
        handleResponse,
    );
}

function getCurrentVerification(profileId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/profiles/google/${profileId}/verifications/current`, requestOptions).then(
        handleResponse,
    );
}

function requestVerification(profileId, method, phoneNumber, emailAddress) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ method, phoneNumber, emailAddress }),
    };
    return fetch(`${BASE_URL}api/profiles/google/${profileId}/verify`, requestOptions).then(handleResponse);
}

function completeVerification(profileId, verificationId, pin) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ verificationId, pin }),
    };
    return fetch(`${BASE_URL}api/profiles/google/${profileId}/verifications/complete`, requestOptions).then(
        handleResponse,
    );
}

export const profilesService = {
    get,
    getFilterData,
    startSync,
    resolveConflictsGoogle,
    resolveConflictsFacebook,
    enableProfileSync,
    disableProfileSync,
    exportCSV,
    getVerificationOptions,
    getCurrentVerification,
    requestVerification,
    completeVerification,
};
